import { useRef } from 'react';
export var useScrollIntoView = function () {
    var elementRef = useRef(null);
    var scrollToElement = function (scrollOptions) {
        var _a;
        (_a = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView(scrollOptions);
    };
    return [elementRef, scrollToElement];
};
